var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionWhiteIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7832 7.16979L46.4082 27.7948V42.2563C46.4082 43.6239 45.865 44.9354 44.898 45.9024C43.931 46.8694 42.6195 47.4126 41.252 47.4126H10.3145C8.94693 47.4126 7.63542 46.8694 6.66843 45.9024C5.70145 44.9354 5.1582 43.6239 5.1582 42.2563V27.7948L25.7832 7.16979ZM42.9707 4.44385V16.4751L36.0957 9.6001V4.44385C36.0957 3.98801 36.2768 3.55084 36.5991 3.22851C36.9214 2.90618 37.3586 2.7251 37.8145 2.7251H41.252C41.7078 2.7251 42.145 2.90618 42.4673 3.22851C42.7896 3.55084 42.9707 3.98801 42.9707 4.44385Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3531 1.00645C23.9977 0.362022 24.8719 0 25.7834 0C26.6949 0 27.5691 0.362022 28.2137 1.00645L51.0628 23.8521C51.3855 24.1748 51.5668 24.6125 51.5668 25.069C51.5668 25.5254 51.3855 25.9631 51.0628 26.2858C50.7401 26.6086 50.3023 26.7899 49.8459 26.7899C49.3895 26.7899 48.9518 26.6086 48.629 26.2858L25.7834 3.43677L2.9378 26.2858C2.61506 26.6086 2.17734 26.7899 1.72092 26.7899C1.2645 26.7899 0.826782 26.6086 0.504046 26.2858C0.181311 25.9631 0 25.5254 0 25.069C0 24.6125 0.181311 24.1748 0.504046 23.8521L23.3531 1.00645Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionWhiteIcon2);
export default __webpack_public_path__ + "static/media/accordion-white-icon2.3938dc45c8d4f8d38a8aed7d784f1807.svg";
export { ForwardRef as ReactComponent };